<template>
  <v-container fluid v-if="trainingDetails">
    <material-card icon="mdi-google-classroom" title="Trainer Feedback">
      <v-row>
        <v-col cols="3">Training Type : </v-col>
        <v-col cols="3">{{ trainingDetails.trainingData.type }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Training Title : </v-col>
        <v-col cols="3">{{ trainingDetails.trainingData.title }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Dates : </v-col>
        <v-col cols="3">From : {{ formatDate(trainingDetails.trainingData.fromDate) }}</v-col>
        <v-col cols="3">To : {{ formatDate(trainingDetails.trainingData.toDate) }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Time : </v-col>
        <v-col cols="3">From : {{ trainingDetails.trainingData.fromTime }}</v-col>
        <v-col cols="3">To : {{ trainingDetails.trainingData.toTime }}</v-col>
      </v-row>
      <v-row>
        <v-col cols="3">Training Location : </v-col>
        <v-col cols="3">{{trainingDetails.trainingData.trainingLocation ? trainingDetails.trainingData.trainingLocation.companyName : 'NA'}}</v-col>

      </v-row>
      <v-row>
        <v-col cols="3">Batch Size : </v-col>
        <v-col cols="3">{{ trainingDetails.trainingData.batchSize }}</v-col>
      </v-row>
      <v-divider></v-divider>
      <div v-for="(item, index) of trainers" :key="index">
        <v-row>
          <v-col cols="3">Trainer {{ index + 1 }} </v-col>
          <v-col cols="3">{{ item.trainerName }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Please rate based on your experience : </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" v-for="(question, i) in item.feedbackQuestions" :key="i">
          {{question.question}}
            <v-rating length="5" v-model="trainers[index].feedbackQuestions[i].givenScore"></v-rating>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Trainer remarks : </v-col>
          <v-col cols="3">
            <v-textarea outlined name="input-7-4" v-model="item.trainerRemark"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">Any other comment/Content remark : </v-col>
          <v-col cols="3">
            <v-textarea outlined name="input-7-4" v-model="item.contentRemark"></v-textarea>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="3">
          <router-link slot="right" :to="{ name: 'AllTrainings' }">
            <v-btn class="px-2 ml-1 ma-1" min-width="0" small>Cancel</v-btn>
          </router-link>
        </v-col>
        <v-col cols="3">
          <v-btn class="px-2 ml-1 ma-1" @click="saveFeedback()" color="success" min-width="0" small>SUBMIT </v-btn>
        </v-col>
      </v-row>
    </material-card>
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import Multiselect from 'vue-multiselect'
import moment from 'moment'
import _ from 'lodash'
export default {
  name: 'RegisterStaff',
  props: {
    trainingID: String
  },
  components: {
    MaterialCard
    // Multiselect
  },
  data () {
    return {
      trainingByTrainers: null,
      trainingType: '',
      registeredClasses: [],
      franchiseeIDs: [],
      selectedStaff: [],
      previousSelectedStaff: [],
      teachersData: [],
      feedbackQuestions: null,
      trainingDetails: null,
      trainingData: [],
      user: '',
      trainerName: '',
      givenScore: 0,
      trainerRemark: '',
      contentRemark: '',
      trainers: []
    }
  },
  created: async function () {
    await this.getFeedbackQuestions()
  },
  methods: {
    getAttendeesDetails: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/teacher-training/get-attendees/${this.trainingID}`)
        this.trainingDetails = data
        this.trainingData = this.trainingDetails.trainingData.trainingTrainerMaps

        this.trainingData.forEach((user) => {
          let firstName = user.user.firstName
          let lastName = user.user.lastName
          user.trainerName = firstName + ' ' + lastName
          user.trainerRemark = ''
          user.contentRemark = ''
          // Deep copy of array using JSON parser so that v-model work properly
          user.feedbackQuestions = _.map(JSON.parse(JSON.stringify(this.feedbackQuestions)), (a) => {
            a.givenScore = 0
            return a
          })
        })

        this.trainers = this.trainingData
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting training data: ${errorMessage}`)
      }
    },
    getFeedbackQuestions: async function () {
      try {
        let response = await http.get(`${constants.API_URL}/api/teacher-training/feedback-questions/get`)
        this.feedbackQuestions = response.data
        this.getAttendeesDetails()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting Data: ${errorMessage}`)
      }
    },
    saveFeedback: async function () {
      try {
        this.isLoading = true
        let feedBackRequest = []
        this.trainers.map((trainer) => {
          feedBackRequest.push({
            trainerID: trainer.trainerUserID,
            trainerRemark: trainer.trainerRemark,
            contentRemark: trainer.contentRemark,
            questions: _.map(trainer.feedbackQuestions, (a) => {
              return {
                question: a.question,
                givenScore: a.givenScore,
                totalScore: a.totalScore
              }
            })
          })
        })
        const data = {
          trainingId: this.trainingID,
          feedback: feedBackRequest
        }
        await http.post(`${constants.API_URL}/api/teacher-training/feedback/add`, data)
        this.okMsg('Feedback saved successfully!')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style scoped>
#abcd {
  color: rgba(0, 0, 0, 0.6);
  font-size: 16px;
}
</style>
